import { API_BILL, API_BILL_TREE } from "@/configs/Apis";
import { Fetcher as Ajax } from "@/utils/Request";
import cloneDeep from "lodash/cloneDeep";
import merge from "lodash/merge";
import { Module } from "vuex";
import baseModule from "./common";

const newModule: Module<any, any> = merge(cloneDeep(baseModule), {
  actions: {
    getBillTree({ commit }: any) {
      return Ajax.queryData(API_BILL_TREE, {}, "GET", false)
        .then(data => {
          let count = 0;
          function execCount(item: any) {
            if (item && item.children) {
              item.children.forEach((child: any) => {
                count += child.count;
              });
            }
          }
          if (data && data.length) {
            execCount(data[0]);
            if (data.length > 1) {
              execCount(data[1]);
            }
          }
          commit(
            "setBillTree",
            [
              {
                title: "全部",
                count: count,
                icon: "all-data",
                billFilter: {}
              }
            ].concat(data)
          );
        })
        .catch(() => {
          commit("setBillTree", [
            {
              title: "全部",
              count: 0,
              icon: "all-data",
              billFilter: {}
            }
          ]);
        });
    },
    addBill(store: any, payload: any) {
      return Ajax.saveData(API_BILL, payload, "POST");
    },
    updateBill(store: any, payload: any) {
      return Ajax.saveData(API_BILL + "/" + payload.id, payload, "PUT");
    },
    deleteBill(store: any, filter: any) {
      return Ajax.saveData(API_BILL, filter, "DELETE");
    }
  },
  mutations: {
    setBillTree(state: any, data: any) {
      state.billTree = data;
    }
  }
});

const oldState = newModule.state as () => Object;

newModule.state = () => ({ ...oldState(), billTree: null });

export default newModule;
